export default __webpack_public_path__ + "static/media/can_we_pretend_like_airpla.6ff2e1ab.png";